import { render, staticRenderFns } from "./TermsDialog.vue?vue&type=template&id=06fa4973&scoped=true&"
import script from "./TermsDialog.vue?vue&type=script&lang=js&"
export * from "./TermsDialog.vue?vue&type=script&lang=js&"
import style0 from "./TermsDialog.vue?vue&type=style&index=0&id=06fa4973&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fa4973",
  null
  
)

export default component.exports